import { isNil, isEmpty } from 'lodash';

/**
 * 동적 트리 검색 제한 기능 관련 Mixin
 * @type {Object}
 */
export default {
  computed: {
    /**
     * 검색어 최소 길이 제한
     * @author Ju
     * @return {Number}
     */
    treeSearchKeywordLimitLength() {
      return this.$store.state.tree.treeSearchKeywordLimitLength;
    },
    /**
     * 검색 불가 단어 배열
     * @author Ju
     * @return {Array}
     */
    treeSearchUnableKeywords() {
      return this.$store.state.tree.treeSearchUnableKeywords;
    },
  },
  methods: {
    /**
     * 검색 가능한 키워드인지 확인한다.
     * @author Ju
     * @param  {String} keyword
     * @return {Object}
     */
    checkSearchableKeyword(keyword) {
      if (!isNil(keyword) && keyword !== '') {
        if (this.treeSearchKeywordLimitLength !== 0 && keyword.length < this.treeSearchKeywordLimitLength) {
          return {
            searchable: false,
            message: `검색어를 ${this.treeSearchKeywordLimitLength}자 이상 입력해주세요.`,
          };
        } else if (!isEmpty(this.treeSearchUnableKeywords)) {
          for (let i = 0; i < this.treeSearchUnableKeywords.length; i += 1) {
            if (this.treeSearchUnableKeywords[i].indexOf(keyword) >= 0) {
              return {
                searchable: false,
                message: '검색어를 구체적으로 입력해주세요.',
              };
            }
          }
        }
      }
      return {
        searchable: true,
      };
    },
    /**
     * 메시지 ID에 적절한 검색 정보 메시지를 반환한다.
     * @author Ju
     * @param  {String} messageId
     * @return {String}
     */
    getSearchInfoMessage(messageId) {
      if (messageId === 'OVER_RESULT_LIMIT_COUNT') {
        return '검색어를 구체적으로 입력해주세요.';
      }
      return null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/tree/search-limit.js